import { motion } from 'framer-motion';
import { Building2, Award, Wrench, MessageCircle } from 'lucide-react';

const reasons = [
  {
    icon: Building2,
    text: 'Erfahrung aus realem Bildungsträgerbetrieb'
  },
  {
    icon: Award,
    text: 'Erfolgreich bestandene Audits ohne Abweichungen'
  },
  {
    icon: Wrench,
    text: 'Praxisnahe Lösungen statt Theorie'
  },
  {
    icon: MessageCircle,
    text: 'Klare und direkte Kommunikation'
  }
];

export const WhyUs = () => {
  return (
    <section data-testid="why-us-section" className="py-24 md:py-32 bg-[#0A0A0A] relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <span className="text-sm uppercase tracking-widest text-primary font-semibold mb-4 block">
              Warum wir
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold tracking-tight mb-8">
              Warum MEHR<span className="text-primary">AZAV</span>
            </h2>
            
            <div className="space-y-6">
              {reasons.map((reason, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="flex items-center gap-5 py-2"
                  data-testid={`why-us-reason-${index}`}
                >
                  <div className="w-14 h-14 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center flex-shrink-0">
                    <reason.icon className="w-6 h-6 text-primary" />
                  </div>
                  <p className="text-white font-medium">{reason.text}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Visual */}
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="relative"
          >
            <div className="bg-card/30 border border-white/10 rounded-2xl p-10">
              <div className="grid grid-cols-2 gap-6">
                <div className="text-center p-6 bg-white/[0.02] rounded-xl border border-white/5">
                  <div className="text-4xl font-heading font-bold text-primary mb-2">50+</div>
                  <div className="text-sm text-muted-foreground">Begleitete Träger</div>
                </div>
                <div className="text-center p-6 bg-white/[0.02] rounded-xl border border-white/5">
                  <div className="text-4xl font-heading font-bold text-primary mb-2">0</div>
                  <div className="text-sm text-muted-foreground">Abweichungen</div>
                </div>
                <div className="text-center p-6 bg-white/[0.02] rounded-xl border border-white/5">
                  <div className="text-4xl font-heading font-bold text-primary mb-2">5+</div>
                  <div className="text-sm text-muted-foreground">Jahre Erfahrung</div>
                </div>
                <div className="text-center p-6 bg-white/[0.02] rounded-xl border border-white/5">
                  <div className="text-4xl font-heading font-bold text-primary mb-2">24h</div>
                  <div className="text-sm text-muted-foreground">Reaktionszeit</div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
